import React, { Component } from "react";
import Header from "./header";
import "./homePage.css";
import Footer from "./footer";
import { Responsive, Container, Grid, Image, Divider } from "semantic-ui-react";
import BoardItem from "./boarditem";

// Presidents
import EricLui from "./img/board2023/1_P Eric Lui -min.jpg";
import SimoneKong from "./img/board2023/2_IPP Simone Kong (President)-min.jpg";
import ConstantMo from "./img/board2023/3_PE_Constant Mo (Vice President)-min.jpg";
import KarenChan from "./img/board2023/4_Treasurer_Karen Chan.jpeg";
import InezWu from "./img/board2023/5_VP_Inez Wu min.jpg";
import JoeyChan from "./img/board2023/6_secretary_Joey Chan.jpeg";
import EdmondChan from "./img/board2023/7_ service director Edmond Chan (Immediate Past President)-min.jpg";
import AlexTsang from "./img/board2023/8_Alex Tsang (fellowship)-min.jpeg";
import MavisChan from "./img/board2023/9_PR_Mavis Chan.jpeg";
import RitaKu from "./img/board2023/10_Foundation_ Rita Ku.jpeg";
import HarrietLi from "./img/board2023/11_ Youth_Harriet Li (Service)-min.jpg";
import VivianChoi from "./img/board2023/12_Vivian Choi (International)-min.jpg";
import WallaceLaw from "./img/board2023/13_Wallace Law (membership)-min.jpg";
import DanielLo from "./img/board2023/14_PPE_Daniel Lo.jpeg";
import BonnieWong from "./img/board2023/15_DEI_Bonnie Wong.jpeg";

import ElsieGung from "./img/board2022/PP Elsie Gung (Public Image)-min.jpg";
import RosennaMak from "./img/board2022/PP Rosenna Mak (Foundation)-min.jpg";
import AlexLau from "./img/board2022/PP Alex Lau (Fellowship)-min.jpeg";
import SharonLaw from "./img/board2022/Sharon Law (PPE)-min.jpg"; //

class Member extends Component {
  // President has to be in the middle among three
  presidents = [
    {
      id: 1,
      name: "Ms. Simone Kong",
      image: SimoneKong,
      title: "Immediate Past president",
      htmlcontent: `I am a member of RCC since 2016. I join RCC because I want to expand my horizon. RCC not only provides a platform where I can serve various disadvantage groups in our society.<br/><br/> I have also serve on the Board of RCC in the past few years which gave me the chance to serve our members.`,
    },
    {
      id: 2,
      name: "Mr. Eric Lui",
      image: EricLui,
      title: "President",
      htmlcontent:
        "It is a great honor to participate in the Rotary Club of the Central to become a character member. In the past 10 years, we have done a lot of different types of services, such as serving the elderly, serving Down's children, and new immigrant families!  So I feel very meaningful and wonderful to be a helper. I hope that our club will be more brilliant and tenacious to serve and We will be able to do more meaningful services and promote society.",
    },
    {
      id: 3,
      name: "Mr. Constant Mo",
      image: ConstantMo,
      imageScale: "1.6,1.6",
      imagePos: "center -35%",
      title: "President Elect",
      htmlcontent: "",
    },
  ];

  board = [
    {
      id: 1,
      name: "Ms. Inez Wu",
      image: InezWu,
      imagePos: "center 25%",
      title: "Vice President",
      htmlcontent: "",
    },
    {
      id: 2,
      name: "Ms. Karen Chan",
      image: KarenChan,
      title: "Treasurer",
      imageScale: "1.8,1.8",
      imagePos: "0% -25%",
      htmlcontent: "",
    },
    {
      id: 3,
      name: "Ms. Joey Chan",
      image: JoeyChan,
      title: "Secretary",
      imagePos: "left top",
      htmlcontent: "",
    },
    {
      id: 4,
      name: "Mr. Edmond Chan",
      image: EdmondChan,
      title: "Service Director",
      imageScale: "1.6,1.6",
      htmlcontent: "",
    },
    {
      id: 5,
      name: "Mr. Alex Tsang",
      image: AlexTsang,
      imagePos: "center 75%",
      title: "Fellowship",
      htmlcontent: "",
    },
    {
      id: 6,
      name: "Ms. Mavis Chan",
      image: MavisChan,
      title: "Public Image",
      imageScale: "1.5,1.5",
      htmlcontent: "",
    },
    {
      id: 7,
      name: "Ms. Rita Ku",
      image: RitaKu,
      title: "Foundation Chair",
      imageScale: "1.6,1.6",
      htmlcontent: "",
    },
    {
      id: 8,
      name: "Ms. Harriet Li",
      title: "Youth Service Chair",
      image: HarrietLi,
      htmlcontent: "",
    },
    {
      id: 9,
      name: "Ms. Vivian Choi",
      image: VivianChoi,
      title: "International Services",
      htmlcontent: `Service Above Self and One Profits Most Who Serves Best, Rotary's official mottoes, can be traced back to the early days of the organization.
<br/><br/>
I am a Vice-President this year and had joined RCC since 2011. I am honour to be part of the group to serve the community. Prior to be a Rotarian, I served as a President in a Rotaract Club after being in the Board of Directors for four years. Joining the Rotary family not only expands my life’s horizon, I have also gained a lot of invaluable memories and friendship.`,
    },
    {
      id: 10,
      name: "Mr. Wallace Law",
      image: WallaceLaw,
      title: "Membership",
      htmlcontent: "",
    },
    {
      id: 11,
      name: "Mr. Daniel Lo",
      image: DanielLo,
      title: "PPE",
      imageScale: "1.2,1.2",
      imagePos: "left top",
      htmlcontent: "",
    },
    {
      id: 12,
      name: "Ms. Bonnie Wong",
      image: BonnieWong,
      title: "DEI",
      imageScale: "1.2,1.2",
      htmlcontent: "",
    },
  ];

  componentWillMount() {}
  render() {
    return (
      <div className="Homepage BoardMemberPage">
        <Header page="aboutus" />

        <div className="homeContentWhite">
          <a id="board">
            <Container>
              <div className="AboutUsText left">
                Rotary Club of Central is committed to achieving high standards
                of club governance.
                <br />
                <br />
                The Board of Directors (the "Board") believes that good club
                governance is the key to enhance our club transparency,
                accountability and credibility, and to attain the confidence of
                our partners and service users.
              </div>
              <div className="AboutUsTitle">
                Board Members of the Rotary Club of Central (2023-2024)
              </div>
              <br />
              <br />

              <div className="boardRowPresidents">
                <Grid centered>
                  <Grid.Row className="boardRowPresidentsRow">
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                      <BoardItem isTopManagement board={this.presidents[0]} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                      <BoardItem isTopManagement board={this.presidents[1]} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                      <BoardItem isTopManagement board={this.presidents[2]} />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
              <Grid centered>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[0]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[1]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[2]} />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[3]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[4]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[5]} />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[6]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[7]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[8]} />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[9]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[10]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[11]} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </a>
        </div>
        <div className="boardBoxes">
          <a
            href="https://www.facebook.com/groups/199332850129610/"
            target="_blank"
            className="boardBox"
          >
            <div className="boardBoxInner">
              <h2 className="boardBoxTitle">Sister Clubs</h2>
              <p className="boardBoxDesc">Rotary Club of Taipei Diamond</p>
            </div>
          </a>
          <div className="boardBox">
            <div className="boardBoxInner">
              <h2 className="boardBoxTitle">Rotaract Club</h2>
              <p className="boardBoxDesc">Rotaract Club of Central</p>
            </div>
          </div>
          <div className="boardBox">
            <div className="boardBoxInner">
              <h2 className="boardBoxTitle">Kideract Club</h2>
              <p className="boardBoxDesc">Kideract Club of Central</p>
            </div>
          </div>
          <div className="boardBox">
            <div className="boardBoxInner">
              <h2 className="boardBoxTitle">Adopt-A-School</h2>
              <p className="boardBoxDesc">Tuen Mun Catholic Secondary School</p>
              <p className="boardBoxDesc">
                Tuen Mun Government Secondary School
              </p>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default Member;
